/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react'

import { Popover, WandSparklesIcon, UnstyledButton } from '@buffer-mono/popcorn'

import { selectGenerateContentLimits } from '~publish/legacy/ai/state/aiLimits/slice'
import { queryLimits } from '~publish/legacy/ai/state/aiLimits/thunks'
import { selectGeneratedIdeas } from '~publish/legacy/ai/state/contentIdeation/slice'
import { useAppSelector, useAppDispatch } from '~publish/legacy/store'

import { GeneratedIdea } from './GeneratedIdea'
import { Questions } from './Questions'
import { UpgradeOptions } from './UpgradeOptions'

import styles from './GenerateIdeasButton.module.css'

import type { JSX } from 'react'

const GenerateIdeasButton = ({
  children,
}: {
  children?: React.ReactNode
}): JSX.Element => {
  const [currentIdea, setCurrentIdea] = React.useState<string | null>(null)
  const [showUpgradeOptions, setShowUpgradeOptions] =
    React.useState<boolean>(false)

  const dispatch = useAppDispatch()

  const { generatedIdeas } = useAppSelector((state) =>
    selectGeneratedIdeas(state),
  )

  const { canGenerateContent, limitsLoaded } = useAppSelector((state) =>
    selectGenerateContentLimits(state),
  )

  React.useEffect(() => {
    if (!limitsLoaded || canGenerateContent) return
    setShowUpgradeOptions(true)
  }, [limitsLoaded])

  React.useEffect(() => {
    const idea = generatedIdeas.length ? generatedIdeas[0] : null
    setCurrentIdea(idea)
    dispatch(queryLimits())
  }, [generatedIdeas])

  const onUpgrade = (): void => {
    setShowUpgradeOptions(true)
  }

  const renderContent = (): JSX.Element => {
    if (showUpgradeOptions) {
      return <UpgradeOptions />
    }

    return currentIdea ? <GeneratedIdea onUpgrade={onUpgrade} /> : <Questions />
  }

  return (
    <Popover>
      <Popover.Trigger className={styles.trigger}>
        {children ?? (
          <UnstyledButton
            className={styles.triggerButton}
            id="generate-ideas-button"
          >
            <WandSparklesIcon />
            Generate Ideas
          </UnstyledButton>
        )}
      </Popover.Trigger>
      <Popover.Content
        className={styles.content}
        sideOffset={5}
        align="center"
        arrow
      >
        {renderContent()}
      </Popover.Content>
    </Popover>
  )
}

export { GenerateIdeasButton }
